import { useTenantDisplayName, useTenantName } from "@/features/branding";

const CO_BRANDED_TENANTS = new Set(["scarritt", "iqvia"]);
const DEFAULT_CLIENT_NAME = "Nmible";

export const useCardClientName = (): string => {
  const tenantName = useTenantName();
  const displayName = useTenantDisplayName();
  return tenantName && CO_BRANDED_TENANTS.has(tenantName.trim().toLowerCase())
    ? (displayName ?? tenantName)
    : DEFAULT_CLIENT_NAME;
};
